import React, { FunctionComponent } from "react"
import DotLoader from "../Loader/DotLoader"
import s from "./DotButton.less"

interface iProps {
  isLoading: boolean
  text: string
  type?: "submit" | "reset" | "button"
  className?: string
  onClick?: () => void
}

const DotButton: FunctionComponent<iProps> = ({
  isLoading,
  text,
  type = "submit",
  className = "btn-bordered",
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={`${isLoading ? s.dotWrap : ""} ${className}`}
    >
      {isLoading ? <DotLoader /> : text}
    </button>
  )
}

export default DotButton
